import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Link, useLocation } from 'react-router-dom';
import { FileTextIcon, MenuIcon, XIcon } from 'lucide-react';
import { OrdersDashboard } from './pages/OrdersDashboard';
import { OrderDetail } from './pages/OrderDetail';
import { CreateOrder } from './pages/CreateOrder';
import { LenderManagement } from './pages/LenderManagement';
function Sidebar() {
  const location = useLocation();
  const navItems = [{
    path: '/orders',
    label: 'Orders',
    icon: FileTextIcon
  }];
  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };
  return <aside className="fixed left-0 top-0 h-screen w-64 bg-white border-r border-slate-100 flex flex-col" data-id="element-0">
      <div className="p-8 border-b border-slate-100" data-id="element-1">
        <h1 className="text-xl font-semibold tracking-tight" style={{
        color: 'var(--nmhl-burgundy)'
      }} data-id="element-2">
          Loan Orders
        </h1>
      </div>

      <nav className="flex-1 p-6 space-y-2" data-id="element-3">
        {navItems.map(item => {
        const Icon = item.icon;
        const active = isActive(item.path);
        return <Link key={item.path} to={item.path} className={`flex items-center space-x-3 px-4 py-3 rounded-xl transition-all duration-200 group ${active ? 'text-white' : 'text-slate-600 hover:bg-slate-50'}`} style={active ? {
          backgroundColor: 'var(--nmhl-burgundy)'
        } : {}} data-id="element-4">
              <Icon className={`w-5 h-5 transition-transform duration-200 ${!active && 'group-hover:scale-110'}`} style={!active ? {
            color: 'var(--nmhl-text-secondary)'
          } : {}} data-id="element-5" />
              <span className="font-medium" data-id="element-6">{item.label}</span>
            </Link>;
      })}
      </nav>
    </aside>;
}
function MobileNav() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const navItems = [{
    path: '/orders',
    label: 'Orders',
    icon: FileTextIcon
  }];
  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };
  return <>
      <div className="lg:hidden fixed top-0 left-0 right-0 h-16 bg-white border-b border-slate-100 flex items-center justify-between px-6 z-50" data-id="element-7">
        <h1 className="text-lg font-semibold" style={{
        color: 'var(--nmhl-burgundy)'
      }} data-id="element-8">
          Loan Orders
        </h1>
        <button onClick={() => setIsOpen(!isOpen)} className="p-2 transition-colors" style={{
        color: 'var(--nmhl-text-secondary)'
      }} data-id="element-9">
          {isOpen ? <XIcon className="w-6 h-6" data-id="element-10" /> : <MenuIcon className="w-6 h-6" data-id="element-11" />}
        </button>
      </div>

      {isOpen && <div className="lg:hidden fixed inset-0 z-40 bg-black/20 backdrop-blur-sm" onClick={() => setIsOpen(false)} data-id="element-12">
          <div className="fixed left-0 top-16 bottom-0 w-64 bg-white border-r border-slate-100 p-6 space-y-2" onClick={e => e.stopPropagation()} data-id="element-13">
            {navItems.map(item => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return <Link key={item.path} to={item.path} onClick={() => setIsOpen(false)} className={`flex items-center space-x-3 px-4 py-3 rounded-xl transition-all duration-200 ${active ? 'text-white' : 'text-slate-600 hover:bg-slate-50'}`} style={active ? {
            backgroundColor: 'var(--nmhl-burgundy)'
          } : {}} data-id="element-14">
                  <Icon className="w-5 h-5" data-id="element-15" />
                  <span className="font-medium" data-id="element-16">{item.label}</span>
                </Link>;
        })}
          </div>
        </div>}
    </>;
}
export function App() {
  return <BrowserRouter data-id="element-17">
      <div className="min-h-screen bg-slate-50" data-id="element-18">
        <div className="hidden lg:block" data-id="element-19">
          <Sidebar data-id="element-20" />
        </div>
        <MobileNav data-id="element-21" />

        <main className="lg:ml-64 pt-16 lg:pt-0 min-h-screen" data-id="element-22">
          <div className="max-w-7xl mx-auto px-8 py-12" data-id="element-23">
            <Routes data-id="element-24">
              <Route path="/" element={<Navigate to="/orders" replace data-id="element-26" />} data-id="element-25" />
              <Route path="/orders" element={<OrdersDashboard data-id="element-28" />} data-id="element-27" />
              <Route path="/orders/new" element={<CreateOrder data-id="element-30" />} data-id="element-29" />
              <Route path="/orders/:orderId" element={<OrderDetail data-id="element-32" />} data-id="element-31" />
              <Route path="/lenders" element={<LenderManagement data-id="element-34" />} data-id="element-33" />
            </Routes>
          </div>
        </main>
      </div>
    </BrowserRouter>;
}